import { Form, Input, Select, Checkbox, Row, Col } from 'antd';
import * as _ from 'lodash';
import * as React from 'react';
import { Subscribe } from 'unstated';

import { debounceRate } from '../../../config/config';
import { StateContainer } from './StateContainer';
import { FormItem } from '../../../components/Form';

import PriceInput from '../../../components/Others/PriceInput';
import ProductTagSelect from '../../../components/Others/ProductTagSelect';
import ProductSelect from 'src/components/Others/ProductSelect';

export interface IGeneralSettingsColProps {
  container: StateContainer;
  isIndividualCustomerVoucher?: boolean;
  onIndividualCustomeVoucherSet?: () => void;
}

export default class GeneralSettingsCol extends React.Component<IGeneralSettingsColProps> {

  public constructor(props: IGeneralSettingsColProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onChange = _.debounce(this.onChange, debounceRate);
  }

  public render() {
    const { container } = this.props;

    return (
      <Subscribe to={[container]}>
        {voucherGroup => (
          <div>
            <FormItem label={'Title'} required={true}>
              <Input
                name={'title'}
                autoFocus={true}
                required={true}
                placeholder="Internal title. For example &quot;Nejvetsi sleva&quot;"
                addonBefore={'Internal'}
                defaultValue={voucherGroup.state.voucherGroup.title}
                onChange={e => {
                  this.onChange('title', e.target.value);
                }}
              />
            </FormItem>
            {/*<FormItem>
              <Checkbox
                checked={this.props.isIndividualCustomerVoucher}
                onChange={() => {
                  if (this.props.onIndividualCustomeVoucherSet) {
                    this.props.onIndividualCustomeVoucherSet();
                  }
                  container.onChange('type', 'percent');
                }}
              >
                Individual Customer Voucher
              </Checkbox>
            </FormItem>*/}
            <FormItem label={'Source'} required={true}>
              <Select
                style={{ width: '100%' }}
                onChange={(value: string) => container.onChange('source', value)}
                placeholder="Select source"
                defaultValue={
                  voucherGroup.state.voucherGroup.source || 'price'
                  // tslint:disable-next-line:jsx-curly-spacing
                }
              >
                <Select.Option key={'recommendedPrice'} value={'recommended'}>
                  Recommended Price
                </Select.Option>
                <Select.Option key={'price'} value={'price'}>
                  Price
                </Select.Option>
              </Select>
            </FormItem>
            <FormItem>
              <Checkbox
                checked={voucherGroup.state.voucherGroup.applyToDiscountedGoods}
                onChange={() => container.onChange('applyToDiscountedGoods', !voucherGroup.state.voucherGroup.applyToDiscountedGoods)}
              >
                Apply vouchers to discounted goods
              </Checkbox>
            </FormItem>
            <FormItem label={'Type'} required={true}>
              <Select
                style={{ width: '100%' }}
                disabled={this.props.isIndividualCustomerVoucher}
                onChange={(value: string) => container.onChange('type', value)}
                placeholder="Select type"
                value={
                  voucherGroup.state.voucherGroup.type || 'percent'
                  // tslint:disable-next-line:jsx-curly-spacing
                }
              >
                <Select.Option key={'amount'} value={'amount'}>
                  Amount
                </Select.Option>
                <Select.Option key={'percent'} value={'percent'}>
                  Percentage
                </Select.Option>
                <Select.Option key={'gift'} value={'gift'}>
                  Gift
                </Select.Option>
                <Select.Option key={'2+1'} value={'2+1'}>
                  2+1
                </Select.Option>
                <Select.Option key={'coupon'} value={'coupon'}>
                  Individual coupon
                </Select.Option>
              </Select>
            </FormItem>
            {/** gift selectbox */}
            {voucherGroup.state.voucherGroup.type === 'gift' && <FormItem label={'Gift'}>
              <ProductSelect
                name={'giftId'}
                multiple={false}
                value={voucherGroup.state.giftId}
                onChange={(e: any) => {
                  container.setState({ giftId: e.target.value });
                }}
              />
            </FormItem>}

            <FormItem label={'Amount'} required={true}>
              {voucherGroup.state.voucherGroup.type === 'amount' && <PriceInput
                name={'fixDiscountAmount'}
                mode={'priceWithout'}
                prices={voucherGroup.state.voucherGroup.fixDiscountAmount || []}
                onChange={(e: any) => this.onChange(e.target.name, e.target.value)}
              /> || null} <br/>
              <Input
                disabled={voucherGroup.state.voucherGroup.type === 'amount'}
                name={'Amount'}
                type={'number'}
                required={true}
                defaultValue={voucherGroup.state.voucherGroup.amount}
                onChange={e => this.onChange('amount', parseFloat(e.target.value))}
              />
            </FormItem>
            {(!this.props.isIndividualCustomerVoucher) && <>
            <Row gutter={15}>
              <Col span={12}>
                <FormItem label={'Min. price of single item (excl. VAT)'}>
                  <PriceInput
                    name={'minimumPricesOfSingleItem'}
                    mode={'priceWithout'}
                    prices={voucherGroup.state.voucherGroup.minimumPricesOfSingleItem || []}
                    onChange={(e: any) => this.onChange(e.target.name, e.target.value)}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label={'Max. price of single item (excl. VAT)'}>
                  <PriceInput
                    name={'maximumPricesOfSingleItem'}
                    mode={'priceWithout'}
                    prices={voucherGroup.state.voucherGroup.maximumPricesOfSingleItem || []}
                    onChange={(e: any) => this.onChange(e.target.name, e.target.value)}
                  />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={15}>
              <Col span={12}>
                <FormItem label={'Min. order total (excl. VAT)'}>
                  <PriceInput
                    name={'minimumPricesOfOrder'}
                    mode={'priceWithout'}
                    prices={voucherGroup.state.voucherGroup.minimumPricesOfOrder || []}
                    onChange={(e: any) => this.onChange(e.target.name, e.target.value)}
                  />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem label={'Max. order total (excl. VAT)'}>
                  <PriceInput
                    name={'maximumPricesOfOrder'}
                    mode={'priceWithout'}
                    prices={voucherGroup.state.voucherGroup.maximumPricesOfOrder || []}
                    onChange={(e: any) => this.onChange(e.target.name, e.target.value)}
                  />
                </FormItem>
              </Col>
            </Row>
            <FormItem label={'Included product tags'}>
              <ProductTagSelect
                name={'includedProductTags'}
                value={voucherGroup.state.voucherGroup.includedProductTags || []}
                onChange={(e: any) => this.onChange(e.target.name, e.target.value)}
              />
            </FormItem>
            <FormItem label={'Excluded product tags'}>
              <ProductTagSelect
                name={'excludedProductTags'}
                value={voucherGroup.state.voucherGroup.excludedProductTags || []}
                onChange={(e: any) => this.onChange(e.target.name, e.target.value)}
              />
            </FormItem>
            </> || ''}
            <FormItem>
              <Checkbox
                name={'active'}
                checked={voucherGroup.state.voucherGroup.active}
                onChange={(e: any) => this.onChange(e.target.name, e.target.checked)}
              >
                Active
              </Checkbox>
            </FormItem>
          </div>
        )}
      </Subscribe>
    );
  }

  private onChange(key: string, val: any) {
    this.props.container.onChange(key, val);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VoucherGroups/VoucherGroupDetail/GeneralSettingsCol.tsx